<div class="columns is-vcentered">
    <div class="column" style="text-align: right;">
        <img src="assets/version2/signup-banner.jpg" alt="">
    </div>
    <div class="column">
        <!-- <div class="heading title is-2">{{ 'LblPWelcomeTxt' | translate }} Iylon</div> -->
        <div class="subHeading title is-4">{{ 'LblPUpdateSubHeading'| translate }}</div>
        <div class="signupFormCls">
            <form [formGroup]="signupform">
                <formly-form [model]="signupmodel" [fields]="signupfields" [options]="signupoptions"
                    [form]="signupform">
                </formly-form>
            </form>
            <div class="signupCnt">
                <div>
                    <button class="button section-header transparent-button"
                        (click)="cancelClicked()">{{'LblCancel'|translate}}</button>
                </div>
                <div style="text-align: right;">
                    <button class="button section-header transparent-button"
                        (click)="registerClicked()">{{'LblUpdateDetails'|translate}}</button>
                </div>
            </div>
        </div>
    </div>
</div>